import React, { Fragment } from  'react';
import sponsorNameStyle from './sponsorName.style';
import { withStyles } from '@material-ui/core/styles';
import {fieldIsActive} from "Common/Validation/ValidSponsor";
import Cookies from 'universal-cookie';
import FieldLoader from 'Common/Loader/FieldLoader/FieldLoader';

const SponsorName = (props) => {
  const {classes} = props;
  const cookies = new Cookies();
  const form = props.form;
  const refEnrollerName = cookies.get('refEnrollerName');
  return (
    <Fragment>
        {props.validating && fieldIsActive("sponsor")({ form }) && <div className={classes.loading}><FieldLoader  isLoading="true" {...props} /></div>}
        {!props.validating && refEnrollerName ? <div className={classes.enrollerNameDis}>{refEnrollerName}</div> : null}
    </Fragment>
  )
}

export default withStyles(sponsorNameStyle)(SponsorName);



// WEBPACK FOOTER //
// ./src/components/StartContainer/Sponsor/SponsorName/SponsorName.js